import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerCertificationType } from '../models/enums/customer-certification-type.enum';
import { CustomerCertification } from '../models/customer-certification.model';

@Component({
    selector: 'historical-customer-certification',
    templateUrl: './historical-customer-certification.html',
    inputs: ['customerNumberId']
})
export class HistoricalCustomerCertificationComponent extends BaseComponent implements OnChanges {
    public certifications: CustomerCertification[];
    public customerNumberId: number;

    private certificationTypes: CustomerCertificationType = new CustomerCertificationType();

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.certifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumberId != null) {
            this.populateHistoricalCertifications(this.customerNumberId);
        }
    }

    populateHistoricalCertifications(customerNumberId: number) {

        this.customerService.getHistoricalCustomerCertifications(customerNumberId)
            .subscribe(result => {
                this.certifications = result;
            },
            e => {
                this.certifications = [];
                console.log('error', e);
            },
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const cert of this.certifications) {
            cert.certificationType = this.getValues(cert.customerCertificationTypeId, this.certificationTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
